import { render } from "./Wrap.vue?vue&type=template&id=670749c2&scoped=true"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"

import "./Wrap.vue?vue&type=style&index=0&id=670749c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670749c2"]])

export default __exports__